import React, { useState } from 'react';
import { useOnboarding } from '../OnboardingContext';
import { httpsCallable } from 'firebase/functions';
import { auth, functions } from '../../../firebase';
import { createUserWithEmailAndPassword, signInWithEmailAndPassword } from 'firebase/auth';

export default function StepReview({ onFinish }) {
  const { state } = useOnboarding();
  const { clearDraft } = useOnboarding();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [debug, setDebug] = useState(null);
  const [password, setPassword] = useState('');
  const [provisioning, setProvisioning] = useState(false);

  const handleCreate = async () => {
    setError('');
    setLoading(true);
    setProvisioning(true);
    try {
      // Ensure user is authenticated; if not, create account inline using ownerEmail and supplied password
      let user = auth.currentUser;
      if (!user) {
        const email = state.ownerEmail;
        if (!email) throw new Error('Owner email missing.');
        if (!password) throw new Error('Please provide a password to create your account.');
        // create account
        try {
          await createUserWithEmailAndPassword(auth, email.trim().toLowerCase(), password);
          // ensure sign-in
          await signInWithEmailAndPassword(auth, email.trim().toLowerCase(), password);
          user = auth.currentUser;
        } catch (acctErr) {
          // surface account creation errors
          throw acctErr;
        }
      }

      const provision = httpsCallable(functions, 'provisionTenant');
      const payload = {
        companyName: state.company.name || state.company.companyName || 'My Company',
        locations: state.locations || [],
        roles: state.roles || [],
        departments: state.departments || [],
        people: state.people || [],
  ownerEmail: state.ownerEmail,
  ownerFirstName: state.ownerFirstName || null,
  ownerLastName: state.ownerLastName || null,
        settings: { hours: state.hours || {} },
      };

      // Retry with exponential backoff
      let attempt = 0;
      const maxAttempts = 3;
      let lastErr = null;
      while (attempt < maxAttempts) {
        try {
          const res = await provision(payload);
          // eslint-disable-next-line no-console
          if (process.env.NODE_ENV !== 'production') console.info('provision response status', res?.status || 'unknown');
          if (res && res.data && res.data.success) {
            const tenantId = res.data.tenantId;
            localStorage.setItem('adminUser', JSON.stringify({ id: auth.currentUser.uid, email: state.ownerEmail, tenantId }));
            try { await clearDraft(); } catch (e) { console.warn('clearDraft failed', e); }
            try { await auth.signOut(); } catch (e) { /* ignore */ }
            window.location.href = '/login';
            return;
          }
          // Non-success response counts as an error to retry
          lastErr = new Error('Provisioning returned non-success');
        } catch (err) {
          lastErr = err;
        }

        attempt += 1;
        if (attempt < maxAttempts) {
          // exponential backoff (200ms, 600ms, ...)
          const waitMs = 200 * Math.pow(3, attempt - 1);
          // small delay to let UI update
          // eslint-disable-next-line no-await-in-loop
          await new Promise((res) => setTimeout(res, waitMs));
        }
      }

      // All attempts exhausted
      const msg = (lastErr && lastErr.message) ? lastErr.message : 'Provisioning failed after multiple attempts.';
      setError(msg);
      setDebug({ err: msg, code: lastErr && lastErr.code, details: lastErr && lastErr.details });
    } catch (err) {
      console.error('Provision error', err);
      setError(err.message || 'Provisioning failed');
    } finally {
      setLoading(false);
      setProvisioning(false);
    }
  };

  return (
    <div style={{padding:24}}>
      <h3>Review & Create Workspace</h3>
      <p>Summary of settings will appear here.</p>
      {!auth.currentUser && (
        <div style={{ marginTop: 12 }}>
          <label style={{ display: 'block', marginBottom: 6 }}>Choose a password to create your account</label>
          <input autoComplete="new-password" name="onboarding-review-password" type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
        </div>
      )}
      {error && <div style={{color:'red'}}>{error}</div>}
      {debug && (
        <div style={{ marginTop: 12, background: '#fff3f3', padding: 8, border: '1px solid #f3c0c0' }}>
          <div><strong>Details:</strong> {debug.err}</div>
          {debug.code && <div style={{ marginTop: 6 }}><strong>Code:</strong> {debug.code}</div>}
          {debug.details && <div style={{ marginTop: 6 }}><strong>Details (server):</strong> <pre style={{whiteSpace:'pre-wrap', margin:0}}>{JSON.stringify(debug.details)}</pre></div>}
          {debug.hint && <div style={{ marginTop: 6 }}>{debug.hint}</div>}
          <div style={{ marginTop: 6 }}>
            <a href={`https://console.firebase.google.com/project/${process.env.REACT_APP_FIREBASE_PROJECT || 'apple-schedule-app'}/functions/logs`} target="_blank" rel="noreferrer">Open Functions logs</a>
          </div>
        </div>
      )}

      <div style={{marginTop:12}}>
  <button onClick={handleCreate} disabled={loading || provisioning}>{(loading || provisioning) ? 'Creating…' : 'Create My Workspace'}</button>
        {error && <button onClick={handleCreate} style={{ marginLeft: 12 }}>Retry</button>}
      </div>
    </div>
  );
}
